export default "__VITE_ASSET__D554BjGl__"